/** @format */
import React, { Fragment, FunctionComponent } from 'react';

import { DEFAULT_TEST_ID, ModalVariant } from '../..';
import { HolographicBackground } from './components/holographic-background';
import { BackgroundProps } from './types';

export const Background: FunctionComponent<BackgroundProps> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    children,
    variant,
}) => {
    if (variant === ModalVariant.HOLOGRAPHIC) {
        return (
            <HolographicBackground
                data-testid={`${dataTestId}__${ModalVariant.HOLOGRAPHIC}`}
                className="holographic-background"
            >
                {children}
            </HolographicBackground>
        );
    }

    return <Fragment>{children}</Fragment>;
};
